import { FETCH_NI_PSEUDOGROUPS } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_NI_PSEUDOGROUPS:
			return action.payload;
		default:
			return state;
	}
};
